import { ComponentProps, useEffect } from 'react';
import classNames from 'classnames';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';
import SaveOrCancel, { SaveOrCancelProps } from './save-or-cancel';
import useDiscardForm from '../hooks/useDiscardForm';

export interface AccountFormProps extends ComponentProps<'form'> {
  title: string;
  subtitle?: string;
  containerClassName?: string;
  requiredLabelIsVisible?: boolean;
  defaultCTASection?: boolean;
  ctaVariant?: SaveOrCancelProps['variant'];
  loading?: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

const AccountForm: React.FC<AccountFormProps> = ({
  className,
  containerClassName,
  title,
  subtitle,
  loading,
  requiredLabelIsVisible,
  ctaVariant,
  defaultCTASection,
  onSubmit,
  children,
}) => {
  const { discardForm } = useDiscardForm();

  const { formatMessage } = useFormat({ name: 'gruenland' });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form className={className} onSubmit={handleSubmit}>
      <Typography className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>{title}</Typography>

      <div className="relative border-neutral-400 pb-2 pt-6 md:mt-6 md:border md:p-8 md:pr-[68px]">
        {subtitle && (
          <Typography className="mb-7 text-[14px] leading-loose text-primary-black md:mb-10 md:text-[16px]">
            {subtitle}
          </Typography>
        )}

        <div className={classNames('max-w-5xl', containerClassName)}>
          {children}

          {defaultCTASection && (
            <div className="mt-6 grid items-center justify-between gap-8 md:flex md:gap-4">
              {requiredLabelIsVisible && (
                <Typography className="text-[14px] leading-[114%] text-secondary-black">
                  {formatMessage({ id: 'common.requiredField', defaultMessage: '* Campo obbligatorio' })}
                </Typography>
              )}

              <SaveOrCancel onCancel={discardForm} onSave={handleSubmit} loading={loading} variant={ctaVariant} />
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default AccountForm;
